import {
  Card,
  Heading,
  Image,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

export default function EmptyState({ isCurrentUser }) {
  return (
    <Card className="flex flex-col gap-6 items-center px-5 py-6">
      <Image
        alt=""
        height={270}
        src="/static/images/illustration-no-comments.webp"
        width={500}
      />

      <Heading className="text-center" level="5" tagName="span">
        {isCurrentUser
          ? "You haven't commented on any solutions yet."
          : 'No comments written yet.'}
      </Heading>

      {isCurrentUser && (
        <>
          <p>
            Reading other people’s code and giving feedback is an awesome way to
            learn more faster. Here are some great benefits of giving code
            reviews:
          </p>

          <ul className="flex flex-col gap-2 list-disc pl-4">
            <li>
              Learn different techniques by seeing how other people have
              approached challenges.
            </li>

            <li>
              Learn to think critically about code and provide constructive
              feedback to others.
            </li>

            <li>
              Practice giving code reviews. This is a critical factor in any
              developer’s role.
            </li>

            <li>
              Demonstrate your ability to provide code reviews to others. This
              would be great to show potential employers to give examples of how
              you communicate with other developers.
            </li>

            <li>
              Give back to the community and engage with others to discuss code.
            </li>
          </ul>

          <p>
            To start giving feedback, first browse solutions and choose one to
            comment on.
          </p>
        </>
      )}

      {isCurrentUser && (
        <LinkWithButtonStyles href="/solutions">
          Browse solutions
        </LinkWithButtonStyles>
      )}
    </Card>
  );
}
